(ns frontend.test.lp-portal.modals.chart-editor.sub
  (:require
   [clojure.edn :as edn]
   [common.localization :as loc]
   [frontend.ui.component.lp-portal.report.company.financials-chart.controller :as financials-controller]
   [frontend.ui.page.lp-portal.report.util :as ru]
   [frontend.ui.page.sub :as page-sub]
   [re-frame.core :as rf]))

(def report-data
  {:financials {:ebita              [3.0
                                     3.7862769587836707
                                     2.950345682169094
                                     6.146161575758759]
                :ebitda             [4.0
                                     3.9928011565355073
                                     3.1765388511353914
                                     6.341277816259037]
                :labels             [2018.0
                                     2019.0
                                     2020.0
                                     2021.0]
                :net-debt           [3.5
                                     4.0
                                     2.7
                                     2.7]
                :net-debt-by-ebitda [47.514
                                     47.3
                                     42.5
                                     43.8]
                :net-sales          [29.0
                                     29.80832587551508
                                     30.644257152129658
                                     55.12033794132855]
                :yield              [4.712307692307692
                                     4.712307692307692
                                     4.712307692307692
                                     4.712307692307692]}})


(def dynamic-data
  {:previous-data-set-published-on   1704172743123
   :previous-data-set-reference-date 1704002804352
   :financials                       {:previous-data     {:ebita              [3.7862769587836707
                                                                               2.950345682169094
                                                                               6.146161575758759
                                                                               5.9234]
                                                          :ebitda             [3.9928011565355073
                                                                               3.1765388511353914
                                                                               6.341277816259037
                                                                               6.0234234]
                                                          :labels             [2019.0
                                                                               2020.0
                                                                               2021.0
                                                                               2022.0]
                                                          :net-debt           [4.0
                                                                               2.7
                                                                               2.7
                                                                               3.2]
                                                          :net-debt-by-ebitda [47.3
                                                                               42.5
                                                                               43.8
                                                                               45.9]
                                                          :net-sales          [29.80832587551508
                                                                               30.644257152129658
                                                                               55.12033794132855
                                                                               48.2304923]
                                                          :yield              [4.712307692307692
                                                                               4.712307692307692
                                                                               4.712307692307692
                                                                               4.712307692307692
                                                                               4.23940203]}
                                      :manual-data       {}
                                      :imported-data-on  1704172743123
                                      :imported-data-by  1704172743123
                                      :selected-data-set :previous-data-set}})

(rf/reg-event-fx
 ::init
 (fn [{db :db} _]
   {:db (assoc db ::dynamic-data dynamic-data)}))

(rf/reg-sub
 ::imported-data-set
 (fn []
   (get-in report-data [:financials])))


(rf/reg-sub
 ::dynamic-data
 (fn [db]
   (get db ::dynamic-data)))

(rf/reg-sub
 ::previous-data-set
 :<-
 [::dynamic-data]
 (fn [dynamic-data _]
   (get-in dynamic-data [:financials :previous-data])))

(rf/reg-sub
 ::previous-data-set-reference-date
 :<-
 [::dynamic-data]
 (fn [dynamic-data _]
   (get-in dynamic-data [:previous-data-set-reference-date])))

(rf/reg-sub
 ::manual-data-set
 :<-
 [::dynamic-data]
 (fn [dynamic-data _]
   (get-in dynamic-data [:financials :manual-data])))

(rf/reg-sub
 ::previous-data-set-label
 :<-
 [::dynamic-data]
 (fn [dynamic-data _]
   (let [previous-data-set-reference-date (get-in dynamic-data [:previous-data-set-reference-date])
         published-on (get-in dynamic-data [:previous-data-set-published-on])
         previous-data (get-in dynamic-data [:financials :previous-data])]
     (when previous-data
       (loc/tr :previous-data-set-option-label
         [(ru/->date-dd-MM-yyyy previous-data-set-reference-date)
          (ru/->date-dd-MM-yyyy published-on)])))))

(rf/reg-sub
 ::manual-data-set-label
 :<-
 [::dynamic-data]
 :<-
 [::page-sub/accounts-by-id]
 (fn [[dynamic-data accounts-by-id] _]
   (let [updated-by (get-in dynamic-data [:financials :manual-data-by])
         updated-on (get-in dynamic-data [:financials :manual-data-on])]
     (when (or updated-by updated-on)
       (loc/tr :manual-data-set-option-label
         [(or (get accounts-by-id updated-by)
              (loc/tr :system))
          (ru/->date-dd-MM-yyyy updated-on)])))))

(rf/reg-sub
 ::imported-data-set-label
 :<-
 [::dynamic-data]
 :<-
 [::page-sub/accounts-by-id]
 (fn [[dynamic-data accounts-by-id] _]
   (let [imported-by (get-in dynamic-data [:financials :imported-data-by])
         imported-on (get-in dynamic-data [:financials :imported-data-on])]
     (when (or imported-by imported-on)
       (loc/tr :imported-data-set-option-label
         [(or (get accounts-by-id imported-by)
              (loc/tr :system))
          (ru/->date-dd-MM-yyyy imported-on)])))))


(rf/reg-sub
 ::selected-data-set
 :<-
 [::dynamic-data]
 (fn [dynamic-data _]
   (let [selected (get-in dynamic-data [:financials :selected-data-set])]
     (cond (keyword? selected)
           selected
           (string? selected)
           (edn/read-string selected)))))

(rf/reg-sub
 ::selected-data
 :<-
 [::manual-data-set]
 :<-
 [::imported-data-set]
 :<-
 [::previous-data-set]
 :<-
 [::selected-data-set]
 (fn [[manual-data imported-data previous-data selected-set] [_]]
   (case selected-set
     :manual-data-set
     manual-data
     :imported-data-set
     imported-data
     :previous-data-set
     previous-data
     nil)))

(rf/reg-sub
 ::previous-data-set-published-on
 :<-
 [::dynamic-data]
 (fn [dynamic-data _]
   (get-in dynamic-data [:previous-data-set-published-on])))

(rf/reg-sub
 ::selected-data-config
 :<-
 [::selected-data]
 (fn [data _]
   (when data
     (financials-controller/company-financials data))))
